import type { DocumentStatus } from '@api';

import type { DocumentUploadProgressPhase } from '../models/document-upload-progress';

/**
 * Maps a server document status onto the phase the upload dialog renders.
 *
 * @param status - the reported document status.
 * @returns the phase, or `undefined` for `Pending`, which the dialog cannot report on — the row keeps its phase.
 */
export function toUploadProgressPhase(status: DocumentStatus): DocumentUploadProgressPhase | undefined {
  switch (status) {
    case 'Uploaded': {
      return 'uploaded';
    }
    case 'Processing': {
      return 'processing';
    }
    case 'Indexed': {
      return 'done';
    }
    case 'Failed': {
      return 'failed';
    }
    default: {
      return undefined;
    }
  }
}
